class purchaseHandler {
  constructor(getSessionContext, purchase) {
    this.getSessionContext = getSessionContext;
    this.purchase = purchase;

    this.handleSessionContextError = this.handleSessionContextError.bind(this);
  }

  handleSessionContextError(sessionContext) {
    return sessionContext.error
      ? Promise.reject(sessionContext.error)
      : Promise.resolve(sessionContext);
  }

  addToCart(items) {
    
    return this.getSessionContext()
      .then(this.handleSessionContextError)
      .then((sessionContext) => this.purchase(sessionContext, items));
  }
}

export default purchaseHandler;
